export default __webpack_public_path__ + "static/card-banner-f07f50fcf97af4bc6ead05900a4b9cda.png";